let supportsPassive = false;
try {
	const opts = Object.defineProperty({}, 'passive', {
		get: function () {
			supportsPassive = true;
			return true;
		},
	});
	window.addEventListener('testPassive', null, opts);
	window.removeEventListener('testPassive', null, opts);
} catch (e) {
	console.error('Error detecting passive event listeners:', e);
}

const content_slider = function (el) {
	let direction_left;
	let wrapper = el.find('.content-slider-wrapper'),
		scroll = el.find('.content-slider-scroll'),
		items = el.find('.content-slider-item'),
		button_left = el.find('.content-slider-control-left'),
		button_right = el.find('.content-slider-control-right'),
		count = items.length,
		item_size = 100,
		scroll_size,
		max_scroll = 0,
		scrolling = false;

	scroll.css('left', '0');

	function size() {
		const el_width = 100;

		if (el.attr('data-content-slider-single') === 'true') {
			item_size = el_width;
			max_scroll = item_size * (count - 1);
		} else if (el.attr('data-content-slider-three') === 'true') {
			if ($(window).width() >= 768) {
				item_size = el_width / 3;
				max_scroll = item_size * (count - 3);
			} else if ($(window).width() >= 580) {
				item_size = el_width / 2;
				max_scroll = item_size * (count - 2);
			} else {
				item_size = el_width;
				max_scroll = item_size * (count - 1);
			}
		} else {
			if ($(window).width() >= 1024) {
				item_size = el_width / 4;
				max_scroll = item_size * (count - 4);
			} else if ($(window).width() >= 768) {
				item_size = el_width / 3;
				max_scroll = item_size * (count - 3);
			} else if ($(window).width() >= 580) {
				item_size = el_width / 2;
				max_scroll = item_size * (count - 2);
			} else {
				item_size = el_width;
				max_scroll = item_size * (count - 1);
			}
		}

		scroll_size = item_size * count;

		scroll.css('width', scroll_size + '%');
	}

	size();

	function slide_left() {
		if (!scrolling) {
			const p = (parseInt(scroll.css('left')) / wrapper.width()) * 100;
			if (p < 0) {
				scroll.animate({ left: p + item_size + '%' }, 300);
				scrolling = true;
				setTimeout(function () {
					scrolling = false;
				}, 300);
			}
		}
	}

	function slide_right() {
		if (!scrolling) {
			const p = (parseInt(scroll.css('left')) / wrapper.width()) * 100;
			if (p > 0 - max_scroll) {
				scroll.animate({ left: p - item_size + '%' }, 300);
				scrolling = true;
				setTimeout(function () {
					scrolling = false;
				}, 300);
			}
		}
	}

	button_left.on('click', function () {
		slide_left();
	});
	button_right.on('click', function () {
		slide_right();
	});

	function set_scroll_position() {
		let pos = parseInt(scroll.css('left')),
			distance = pos % ((item_size / 100) * el.width()),
			new_pos = pos - distance;

		if (new_pos !== pos) {
			if (direction_left)
				new_pos = new_pos - (item_size / 100) * el.width();

			scroll.stop().animate({ left: new_pos + 'px' }, 150);
		}
	}

	let dragging = false;
	direction_left = false;
	let p = 0;
	simulateTouchEvents(scroll);
	scroll
		.on('mousedown', function (e) {
			dragging = true;
			wrapper[0].style =
				'-webkit-touch-callout: none;' +
				'-webkit-user-select: none;' +
				'-khtml-user-select: none;' +
				'-moz-user-select: none;' +
				'-ms-user-select: none;' +
				'user-select: none';
		})
		.on('mouseup', function (e) {
			dragging = false;
			wrapper[0].style = '';
			p = 0;
			set_scroll_position();
		})
		.on('mousemove', function (e) {
			if (p === 0) p = e.pageX;

			if (dragging && (p - e.pageX > 4 || p - e.pageX < 4)) {
				if (p - e.pageX > 0) direction_left = true;
				else if (p - e.pageX < 0) direction_left = false;

				const new_pos = parseInt(scroll.css('left')) - (p - e.pageX);
				if (
					new_pos < 0 &&
					new_pos > 0 - (max_scroll / 100) * el.width()
				)
					scroll.css('left', new_pos + 'px');
			}

			p = e.pageX;
		});

	$(window).on('resize', function () {
		size();
		direction_left = false;
		set_scroll_position();
	});
	el.removeClass('content-slider-hidden');
};
(function (window, $) {
	if (typeof $ !== 'function') {
		return console.error(
			'content-slider.js: jQuery is missing, load it please',
		);
	}

	$('.content-slider').each(function () {
		content_slider($(this));
	});
})(window, window.jQuery);

function simulateTouchEvents(oo, bIgnoreChildren) {
	if (!$(oo)[0]) {
		return false;
	}

	if (!window.__touchTypes) {
		window.__touchTypes = {
			touchstart: 'mousedown',
			touchmove: 'mousemove',
			touchend: 'mouseup',
		};
		window.__touchInputs = {
			INPUT: 1,
			TEXTAREA: 1,
			SELECT: 1,
			OPTION: 1,
			input: 1,
			textarea: 1,
			select: 1,
			option: 1,
		};
	}

	$(oo).on(
		'touchstart touchmove touchend',
		function (ev) {
			const bSame = ev.target === this;
			if (bIgnoreChildren && !bSame) {
				return;
			}

			let b = !bSame && ev.target.__ajqmeclk, // Get if object is already tested or input type
				e = ev.originalEvent;
			if (
				b === true ||
				!e.touches ||
				e.touches.length > 1 ||
				!window.__touchTypes[e.type]
			) {
				return;
			} //allow multi-touch gestures to work

			const oEv =
				!bSame && typeof b !== 'boolean'
					? $(ev.target).data('events')
					: false;
			if (!bSame) {
				let clickHandler = false;
				if (oEv) {
					clickHandler =
						oEv['click'] ||
						oEv['mousedown'] ||
						oEv['mouseup'] ||
						oEv['mousemove'];
				}
				b = ev.target.__ajqmeclk = clickHandler;
			} else {
				b = false;
			}

			if (b || window.__touchInputs[ev.target.tagName]) {
				return;
			} //allow default clicks to work (and on inputs)

			// https://developer.mozilla.org/en/DOM/event.initMouseEvent for API
			const touch = e.changedTouches[0],
				newEvent = document.createEvent('MouseEvent');
			newEvent.initMouseEvent(
				window.__touchTypes[e.type],
				true,
				true,
				window,
				1,
				touch.screenX,
				touch.screenY,
				touch.clientX,
				touch.clientY,
				false,
				false,
				false,
				false,
				0,
				null,
			);

			touch.target.dispatchEvent(newEvent);
			e.preventDefault();
			ev.stopImmediatePropagation();
			ev.stopPropagation();
			ev.preventDefault();
		},
		supportsPassive ? { passive: false } : false,
	);
	return true;
}
